export * from "@punchup/data/legacy/comedian";
